import axios from "axios";

export default {
  getSmscList({ commit }, list) {
    return axios({
      url: "/smsc_connection/list",
      method: "GET",
      params: {
        per_page: list.per_page || 10,
        smsc_id: list.searched_text ? `*${list.searched_text}*` : '',
        page: list.page || 0
      }
    }).then(res => {
      const { items: smscList, total, per_page } = res.data.payload;
      commit('SET_SMSC_LIST', { smscList, total, per_page });
      return res.data.payload;
    });
  },
  getSmsc({ commit }, id) {
    return axios({
      url: "/smsc_connection/" + id,
      params: {},
      method: "GET"
    })
      .then(res => {
        commit('SET_SMSC', res.data.payload);
        return res.data.payload;
      });
  },
  addSmsc({ commit }, payload) {
    return axios({
      url: "/smsc_connection",
      data: payload,
      method: "POST"
    })
      .then(res => {
        return res;
      });
  },
  editSmsc({ commit }, { payload, id }) {
    return axios({
      url: "/smsc_connection/" + id,
      data: payload,
      method: "PATCH"
    })
      .then(res => {
        return res;
      });
  },
  deleteSmsc({ commit }, id) {
    return axios({
      url: "/smsc_connection/" + id,
      method: "DELETE"
    })
      .then(res => {
        commit('REMOVE_SMSC', id);
        return res;
      });
  }
};
